// extracted by mini-css-extract-plugin
export default {"wrapper":"logo-module--wrapper--2eb4a","icon":"logo-module--icon--b53e1"};